import React from "react";
import styled from "styled-components";
import Link from "next/link";
import { useTranslation } from "react-i18next";

type TBlogItem = {
  id: number;
  bg: string;
  title: string;
};

export default function BlogItem({ id, bg, title }: TBlogItem) {
  const { t } = useTranslation();
  return (
    <ItemWrapper href={`/learn/blog/${id}`}>
      <ThumbArea id="thumb" $bg={bg}></ThumbArea>
      <ContentArea>
        <Title>{title}</Title>
        <ReadButton id="readBtn" href={`/learn/blog/${id}`}>
          {t("main.blog.read-more")} ↗
        </ReadButton>
      </ContentArea>
    </ItemWrapper>
  );
}

const ItemWrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  width: calc(25% - 20px);
  height: 711px;
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
  &:hover {
    & > #thumb {
      transition: 0.3s ease-out;
      box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.2);
      transform: scale(1.05);
    }
    & > div > #readBtn {
      background-color: black;
      color: white;
      transition: 0.3s ease-out;
    }
  }

  @media (max-width: 1000px) {
    width: calc(50% - 20px);
  }

  @media (max-width: 600px) {
    width: calc(100% - 20px);
  }
`;
const ThumbArea = styled.div<{ $bg: string }>`
  width: 100%;
  height: 300px;
  background: url(${({ $bg }) => $bg});
  background-size: cover;
  barckground-repeat: no-repeat;
  transition: 0.3s ease-out;
`;
const ContentArea = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 32px;
  box-sizing: border-box;
`;
const Title = styled.p`
  height: 230px;
  font-size: 1.6rem;
  line-height: 32px;
  box-sizing: border-box;
  color: #515151;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ReadButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: 122px;
  height: 40px;
  margin-bottom: 12px;
  font-size: 14px;
  flex-direction: column;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  transition: 0.3s ease-out;
  &:hover {
    background-color: black;
    color: white;
    transition: 0.3s ease-out;
  }
`;
